module.exports = __webpack_public_path__ + "img/5_23.4b4ffaeb.png";